import { enqueueSnackbar, UploadMultipleFiles, DownloadFile, UploadFiles } from 'actions';

import {
	GetKpiFilesTreeRequest,
	RunKpiFilesParserRequest,
	GetTreeLastUpdateRequest,
	SyncFtpTreeRequest,
	GetKpiProcessTableRequest,
	SearchFTPDirectoryRequest
} from '../requests/DriveTestUploadRequests';

export const TOGGLE_KPIS_UPLOAD_DIALOG = 'TOGGLE_KPIS_UPLOAD_DIALOG';
export const GET_KPI_FILES_TREE = 'GET_KPI_FILES_TREE';
export const GET_TREE_LAST_UPDATE = 'GET_TREE_LAST_UPDATE';
export const GET_KPI_PROCESS_TABLE = 'GET_KPI_PROCESS_TABLE';
export const SET_SELECT_FILES = 'SET_SELECT_FILES';

const onSetSelectedFiles = (value) => ({
	type: SET_SELECT_FILES,
	selectedFiles: value
});

export const SetSelectedFiles = (value) => (dispatch) => {
	dispatch(onSetSelectedFiles(value));
};

const onToggleKpisUploadDialog = (visible) => ({
	type: TOGGLE_KPIS_UPLOAD_DIALOG,
	visible
});

export const ToggleKpisUploadDialog = (visible) => dispatch => {
	dispatch(onToggleKpisUploadDialog(visible));
};

const onGetKpiFilesTree = (value) => ({
	type: GET_KPI_FILES_TREE,
	kpiFilesTree: value
});

export const GetKpiFilesTree = (userId) => async (dispatch) => {
	await GetKpiFilesTreeRequest(userId).then(response => {
		dispatch(onGetKpiFilesTree(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

const onGetKpiProcessTable = (value) => ({
	type: GET_KPI_PROCESS_TABLE,
	kpiProcessTable: value
});

export const GetKpiProcessTable = () => async (dispatch) => {
	await GetKpiProcessTableRequest().then(response => {
		dispatch(onGetKpiProcessTable(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

const onGetTreeLastUpdate = (value) => ({
	type: GET_TREE_LAST_UPDATE,
	treeLastUpdate: value
});

export const GetTreeLastUpdate = () => async (dispatch) => {
	await GetTreeLastUpdateRequest().then(response => {
		dispatch(onGetTreeLastUpdate(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const SyncFtpTree = (userId) => async (dispatch) => {
	await SyncFtpTreeRequest(userId).then(response => {
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const RunKpiFilesParser = (userId, selectedFiles) => async (dispatch) => {
	await RunKpiFilesParserRequest(userId, selectedFiles).then(response => {
		if (response.data.includes('Unavailable')) {
			dispatch(enqueueSnackbar({ message: response.data, options: { variant: 'warning' } }));
		} else {
			dispatch(enqueueSnackbar({ message: response.data, options: { variant: 'success' } }));
		}
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const SearchFTPDirectory = (userId, searchPath) => async (dispatch) => {
	await SearchFTPDirectoryRequest(userId, searchPath).then(response => {
		dispatch(onGetKpiFilesTree(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};
